import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import Copyright from "./Copyright";

const Footer = () => {
  return (
    <>
      <footer className="footer">

        <svg className="footer-wave" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path d="M0,160L80,149.3C160,139,320,117,480,122.7C640,128,800,160,960,160C1120,160,1280,128,1360,112L1440,96V320H0Z"></path>
        </svg>

        <div className="footer-row">
          <div className="footer-col">
            <h3>About</h3>
            <ul>
              <li><Link to="/about/history">History</Link></li>
              <li><Link to="/about/vision-mission">Vision & Mission</Link></li>
              <li><Link to="/about/correspondent-message">Correspondent Message</Link></li>
              <li><Link to="/about/principal-message">Principal Message</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h3>Admission</h3>
            <ul>
              <li><Link to="/admission">Admission</Link></li>
              <li><Link to="/admission/process">Admission Process</Link></li>
              <li><Link to="/admission/rules">Rules & Regulations</Link></li>
              <li><Link to="/admission/scholarship">Scholarship</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h3>Academics</h3>
            <ul>
              <li><Link to="/academics/kindergarten">Kindergarten School</Link></li>
              <li><Link to="/academics/secondary">Secondary School</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h3>Facilities & Activities</h3>
            <ul>
              <li><Link to="/facilities/lab">Lab</Link></li>
              <li><Link to="/facilities/library">Library</Link></li>
              <li><Link to="/facilities/transport">Transportation</Link></li>
              <li><Link to="/activities">Activities</Link></li>
              <li><Link to="/activities/scout">Scout</Link></li>
              <li><Link to="/activities/junior-red-cross">Junior Red Cross</Link></li>
            </ul>
          </div>
        </div>

        <hr className="footer-separator" />

        <div className="footer-extra-links">
          <Link to="/alumni">Alumni</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/contact">Contact Us</Link>
        </div>

        <div className="footer-social">
          <a href="#" className="icon fb"><i className="fab fa-facebook-f"></i></a>
          <a href="#" className="icon ig"><i className="fab fa-instagram"></i></a>
          <a href="#" className="icon yt"><i className="fab fa-youtube"></i></a>
          <a href="#" className="icon ln"><i className="fab fa-linkedin-in"></i></a>
        </div>

      </footer>

      <Copyright />
    </>
  );
};

export default Footer;
